<template>
    <button
        @click="showPersonalNote()"
        class="btn btn-light-primary ml-4 dm-btn-min-width"
    >
        <span class="svg-icon">
            <ClipboardListSvg />
        </span>
        {{ translate("Personal Note") }}
    </button>
</template>

<script>
import ClipboardListSvg from "@/svg/ClipboardListSvg.vue";

export default {
    components: { ClipboardListSvg },

    props: ["personal_note", "company_name"],

    computed: {
        messagedHtml() {
            return (
                '<div class="d-flex justify-content-between flex-wrap text-left my-2 mb-6 text-dark-75 font-weight-bold dm-messages-modal-list"><div class="col-12 font-weight-normal text-dark-50 py-2">' +
                this.personal_note +
                "</div></div>"
            );
        },
    },

    methods: {
        showPersonalNote() {
            this.$swal({
                title:
                    this.translate("Personal Note to") +
                    " " +
                    this.company_name,
                html: this.messagedHtml,
                icon: "info",
                buttonsStyling: false,
                confirmButtonText:
                    "<i class='icon-lg la la-check-circle-o'></i> " +
                    this.translate("Cool, thanks"),
                showCancelButton: false,
                customClass: {
                    confirmButton: "btn btn-success",
                },
                width: "50rem",
            });
        },
    },
};
</script>
